const { quickAddCache } = window.BAO.Caches

export class ProductQuickAddLoader extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.getProduct = this.getProduct.bind(this)

    this.listeners.add(this, 'focus', this.getProduct)
    this.listeners.add(this, 'mouseenter', this.getProduct)
  }

  async getProduct () {
    await quickAddCache.get(this.dataset.productHandle)

    this.listeners.remove('focus', this.getProduct)
    this.listeners.remove('mouseenter', this.getProduct)
  }
}

if (!customElements.get('product-quick-add-loader')) {
  customElements.define('product-quick-add-loader', ProductQuickAddLoader)
}

export class ProductQuickAdd extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.listeners.add(document.body, 'site-drawers:open', event =>
      this.handleDrawerOpen(event),
    )
  }

  /**
   * @param {CustomEvent<{
   *  key: string;
   *  trigger: HTMLElement;
   * }>} event
   */
  async handleDrawerOpen (event) {
    if (event.detail.key !== 'product-quick-add') {
      return
    }

    const { productHandle: handle } = event.detail.trigger.dataset

    if (event.detail.trigger.dataset.productOnlyDefaultVariant === 'true') {
      window.BAO.Cart.addItem([
        {
          id: event.detail.trigger.dataset.productVariantId,
          product_id: event.detail.trigger.dataset.productId,
          quantity: 1,
        },
      ])
    } else {
      this.renderWithProduct(handle)
    }
  }

  /** @param {string} handle */
  async renderWithProduct (handle) {
    this.isBusy = true

    this.innerHTML = await quickAddCache.get(handle)

    this.isBusy = false
  }

  get isBusy () {
    return this.getAttribute('aria-busy') === 'true'
  }

  set isBusy (isBusy) {
    this.setAttribute('aria-busy', String(isBusy))
  }
}

if (!customElements.get('product-quick-add')) {
  customElements.define('product-quick-add', ProductQuickAdd)
}
